import React, { useEffect } from 'react';
import authService from '../../services/authService';

export default function SilentRenew() {
    useEffect(() => {
        authService.signinSilentCallback()
            .then(function () {

            })
            .catch(function (e) {
            });
    }, []);

    return (
        <React.Fragment></React.Fragment>
    );
}
